import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "breadcrumb-card mb-25 d-md-flex align-items-center justify-space-between",
  style: {"margin-top":"50px"}
}
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "breadcrumb list-unstyled mt-0 mb-0 pl-0" }
const _hoisted_4 = { class: "breadcrumb-item d-inline-block position-relative" }
const _hoisted_5 = {
  key: 0,
  class: "breadcrumb-item d-inline-block position-relative"
}
const _hoisted_6 = { class: "breadcrumb-item d-inline-block position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1),
    _createElementVNode("ol", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          to: _ctx.homeUrl,
          class: "d-inline-block position-relative"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, " home ", -1),
            _createTextVNode(" Mahai ", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.subTitle)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_ctx.subTitle), 1))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.pageTitle), 1)
    ])
  ]))
}